var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('b-col',{staticClass:"menu-container",attrs:{"cols":"12","md":"3","lg":"2"}},[_c('menu-component',{on:{"updateFilter":function($event){_vm.receivedFilter = $event}}})],1),_c('b-col',{attrs:{"cols":"12","md":"9","lg":"10"}},[_c('TableComponent',{attrs:{"items":_vm.errors,"fields":_vm.fields}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }